import { CalculatorInitialState } from './types';

export const buildInitialState = ({
  pricePerPod,
}: {
  pricePerPod: number;
}): CalculatorInitialState => ({
  podPackPrice: pricePerPod,
});
